import { CancelToken } from 'axios';
import { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store';
import { getOptionsEmployee, selectOptionsEmployee, selectOptionsEmployeeState } from '../../../store/entities/optionsEmployee';
import { FetchState } from '../../../store/fetchState';
import { getFirstLastNameAutocomplete, getFirstLastNameObj } from '../../../utils/format';
import { QcsAutocompleteWithoutFormik } from '../form/QcsAutocompleteWithoutFormik';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

interface Props {
  filterOutNonHumanRoles?: boolean;
  value?: ReferenceDto | ReferenceDto[];
  onChange: (value?: ReferenceDto) => void;
  multiple?: boolean;
}

export const GridFilterEmployee: FC<Props> = ({ filterOutNonHumanRoles, value, onChange, multiple = false }) => {
  const dispatch = useAppDispatch();
  const optionsEmployee = useAppSelector(selectOptionsEmployee);
  const optionsEmployeeState = useAppSelector(selectOptionsEmployeeState);

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsEmployee(filterOutNonHumanRoles, search, cancelToken));
  };

  const handleChange = (value?: ReferenceDto | ReferenceDto[] | null) => {
    onChange((value as ReferenceDto) ?? undefined);
  };

  return (
    <QcsAutocompleteWithoutFormik
      multiple={multiple}
      options={optionsEmployee}
      loading={optionsEmployeeState === FetchState.Loading}
      loadingError={optionsEmployeeState === FetchState.Error}
      loadOptions={loadOptions}
      value={value ?? (multiple ? [] : undefined)}
      getOptionId={(option: ReferenceDto) => option.id!}
      getOptionName={getFirstLastNameObj}
      getValueIfNotFound={getFirstLastNameAutocomplete}
      onChange={handleChange}
    />
  );
};

interface EmployeeWrapperProps {
  value?: ReferenceDto;
  onChange: (value?: ReferenceDto) => void;
}

/**
 * Employee wrapper that filters out non-human roles
 * @param value
 * @param onChange
 * @constructor
 */
export const EmployeeWrapper: FC<EmployeeWrapperProps> = ({ value, onChange }) => {
  return <GridFilterEmployee filterOutNonHumanRoles={true} value={value} onChange={onChange} />;
};

/**
 * Multiple Employee wrapper that filters out non-human roles
 * @param value
 * @param onChange
 * @constructor
 */
export const MultipleEmployeeWrapper: FC<EmployeeWrapperProps> = ({ value, onChange }) => {
  return <GridFilterEmployee multiple filterOutNonHumanRoles={true} value={value} onChange={onChange} />;
};
